import { WarningLevel } from 'src/interfaces/attendance'

export const JOURNAL_SECTIONS = {
  attachments: 'Attachments',
  journalDate: 'Journal Date & Time',
  focusAreaIds: 'Focus Areas',
  description: 'Description',
  ActivityType: {
    FOOD: {
      meals: 'Meals',
    },
    POTTY: {
      time: 'Time',
      toiletType: 'Toilet Type',
      toilet: 'Action',
      hadAccident: 'Accident Status',
    },
    NAP: {
      napDate: 'Nap Tracking',
      isNapStart: 'Nap Tracking',
    },
    HEALTH: {
      title: 'Title',
      timeIdentified: 'Time Identified',
      temperature: 'Temperature',
      temperatureUnit: 'Temperature',
      symptoms: 'Symptoms',
      isFirstAidNeeded: 'First Aid',
      firstAidDescription: 'First Aid',
      adminNotes: 'Administrative Notes',
    },
    MEDICATIONS: {
      givenTime: 'Time Given',
      name: 'Medication Name',
      dosage: 'Dosage',
      administeredBy: 'Administered By',
    },
    INCIDENT: {
      title: 'Incident/Accident Title',
      time: 'Time of Incident/Accident',
      spaceId: 'Location',
      observedBy: 'Observed By',
      description: 'Incident Description',
      incidentDetail: 'Additional Details',
      incidentResolution: 'Resolution/Action Taken',
      isFirstAidNeeded: 'First Aid',
      firstAidDescription: 'First Aid',
      isGuardianNotifiedImmediately: 'Additional Guardian Contact',
      guardianNotificationDescription: 'Additional Guardian Contact',
      adminNotes: 'Administrative Notes',
    },
    MEETING: {
      title: 'Title',
      time: 'Time',
    },
    NOTES: {
      title: 'Title',
    },
  },
}

export const APP = {
  refreshTokenInSeconds: 60 * 30, // 30 mins
  refreshTokenPerSeconds: 60 * 5, // 5 mins
  allowableInactiveSeconds: 8 * 60 * 60, // 8 hours
  deviceCodeKey: 'deviceCode',
}

export const ApprovalStatus = {
  pending: 'pending',
  approved: 'approved',
}

export const DATE_FORMATS = {
  date: 'YYYY-MM-DD',
  year: 'YYYY',
  dateSlash: 'YYYY/MM/DD',
  monthAndDay: 'MM-DD',
  time: 'h:mm:ss A',
  shortTime: 'hh:mm A',
  shortTimeNoLeadingZero: 'h:mm A',
  datetime: 'YYYY-MM-DD hh:mm A',
  datetime2: 'YYYY-MM-DDTHH:mm:ss',
  humanreadable: 'MMM DD YYYY',
  humanreadableLongMonth: 'MMMM DD YYYY',
  dateTimeHumanReadable: 'MMM DD YYYY hh:mm A',
  defaultDate: 'YYYY/MM',
}

export const ENV = {
  DEV: 'DEV',
  UAT: 'UAT',
  PRD: 'PRD',
}

export const SERVICES = {
  attendance: 'cfattendanceservice',
  auth: 'cfcoreauthservice',
  client: 'cfcoreclientservice',
  log: 'cfcorelogservice',
  mgmt: 'cfcoreauthservice',
  res: 'cfcoreresourceservice',
  pay: 'cfcorepaymentservice',
  payProcessing: 'cfpayprocessservice',
  ops: 'cfcoreoperationservice',
  learn: 'cflearningservice',
  sche: 'cfcorescheduleservice',
  pub: 'cfcorepublicservice',
  per: 'cfcorepersonnelservice',
  agg: 'cfcoreaggregateservice',
  form: 'cfcoreformservice',
  file: 'cfcorefileservice',
  event: 'cfcoreeventservice',
  notification: 'cfnotificationservice',
  signalR: 'cfcoresignalrservice',
  report: 'cfreportingservice',
  upload: 'cfuploadservice',
  messaging: 'cfmessagingservice',
}

export const ENROLLMENTSTATUS = {
  Complete: 'Complete',
  Waitlist: 'Waitlist',
  Deny: 'Deny',
  EndingEnrollmentComplete: 'Ending-Enrollment-Complete',
}

export const APIS = {
  absence: 'absence',
  accounts: 'accounts',
  acknowledge: 'acknowledge',
  acknowledged: 'acknowledged',
  acknowledgeUrgent: 'acknowledgeUrgent',
  activeCampaign: 'activeCampaign',
  add: 'add',
  adjustmentExpiries: 'adjustmentExpiries',
  adjustments: 'adjustments',
  adminMessaging: 'adminMessaging',
  admins: 'admins',
  ageDictionary: 'ageDictionary',
  agreementsAndPolicies: 'agreementsAndPolicies',
  allNames: 'allNames',
  announcements: 'announcements',
  approve: 'approve',
  attendance: 'attendances',
  attendanceTeams: 'attendances/teams',
  attendeeLogs: 'attendeeLogs',
  attendanceEditRequests: 'attendanceEditRequests',
  attendees: 'attendees',
  attendeesUpcoming: 'attendees/upcoming',
  auth: 'auth',
  authorizedDeviceAccess: 'authorizedDeviceAccess',
  authorizedMembers: 'authorizedMembers',
  billings: 'billings',
  broadcast: 'broadcast',
  broadcastConversations: 'broadcastConversations',
  broadcastMessages: 'broadcastMessages',
  calendars: 'calendars',
  tours: 'tours',
  availability: 'availability',
  permissions: 'permissions',
  slots: 'slots',
  center: 'center',
  centerFinancials: 'centerFinancials',
  centers: 'centers',
  certifications: 'certifications',
  cfInvoices: 'cfInvoices',
  cfPayments: 'cfPayments',
  check: 'check',
  CheckADFPipelineRunStatus: 'CheckADFPipelineRunStatus',
  checkIn: 'checkIn',
  checkOut: 'checkOut',
  clear: 'clear',
  clearAll: 'clear-all',
  clientOnboarding: 'clientOnboarding',
  clientUsers: 'clientusers',
  clone: 'clone',
  config: 'config',
  connect: 'connect',
  conversations: 'conversations',
  convertTimeFromCurrentUTC: 'convertTimeFromCurrentUTC',
  ConvertTimeToUTC: 'ConvertTimeToUTC',
  copy: 'copy',
  count: 'count',
  createAdminStaff: 'createAdminStaff',
  createOrgInfo: 'createOrgInfo',
  creditRefund: 'creditRefund',
  csv: 'csv',
  curriculum: 'curriculum',
  customBilling: 'customBilling',
  customFields: 'customFields',
  customForm: 'forms/custom',
  customFormTemplate: 'forms/custom/templates',
  customQuestions: 'customQuestions',
  customs: 'custom',
  dashboard: 'dashboard',
  depositGroupsSettle: 'deposits/settle',
  deposits: 'deposits',
  deviceAuthorization: 'deviceAuthorization',
  deviceRegister: 'devices/register',
  deviceUnregisterByDeviceId: 'devices/unregister/device',
  direct: 'direct',
  directory: 'directory',
  disconnect: 'disconnect',
  discounts: 'discounts',
  discoveryTopic: 'discoveryTopic',
  domain: 'domain',
  domainAuth: 'domainAuth',
  domains: 'domains',
  dropInRoster: 'dropInRoster',
  dropOff: 'dropOff',
  editOrgInfo: 'editOrgInfo',
  emailHistoryList: 'emailHistoryList',
  clientEmailHistoryList: 'client/emailHistoryList',
  emailMissingOnboardingInformation: 'emailMissingOnboardingInformation',
  emails: 'emails',
  emergencyInfo: 'reports/emergencyInfo',
  enrollmentCustomFields: 'enrollmentCustomFields',
  enrollments: 'enrollments',
  events: 'events',
  failedCharges: 'failedCharges',
  families: 'families',
  familiesByIds: 'familiesByIds',
  family: 'family',
  familyBulkUpload: 'familyBulkUpload',
  featureFlag: 'featureFlag',
  file: 'file',
  files: 'files',
  flaggedMembers: 'flaggedMembers',
  focusArea: 'focusArea',
  folders: 'folders',
  form: 'forms',
  getattendancelogreport: 'getattendancelogreport',
  groupchats: 'groupchats',
  groupedSettlement: 'groupedSettlement',
  groups: 'groups',
  growthIndicator: 'growthIndicator',
  hiddenExpiriesEvents: 'hiddenExpiriesEvents',
  holidayPayStrategy: 'holiday-pay-strategy',
  holidays: 'holidays',
  ical: 'ical',
  immunizationRecord: 'immunizationRecord',
  import: 'import',
  importers: 'importers',
  inactiveStudents: 'inactiveStudents',
  inapp: 'inapp',
  inbox: 'inbox',
  infoChanges: 'infoChanges',
  internal: 'internal',
  invoices: 'invoices',
  itemCatalog: 'orgInfo/itemCatalogs',
  journals: 'journals',
  kiosk: 'kiosk',
  kioskSettings: 'kioskSettings',
  learningOutcome: 'learningOutcome',
  leave: 'leave',
  lesson: 'lesson',
  lessonPlans: 'lessonPlans',
  library: 'library',
  locations: 'orgInfo/locations',
  login: 'login',
  logs: 'logs',
  manualPayment: 'manualPayment',
  manualPayments: 'manualPayments',
  marketplace: 'marketplace',
  mealAdjustments: 'mealAdjustments',
  mealsDashboard: 'mealsDashboard',
  memberListForVolunteerExpiary: 'memberListForVolunteerExpiary',
  members: 'members',
  messages: 'messages',
  mixedTeamRatioRules: 'mixedTeamRatioRules',
  monthlyClaims: 'monthlyClaims',
  mute: 'mute',
  napTime: 'napTime',
  negotiate: 'negotiate',
  notifications: 'notifications',
  notificationSettings: 'notificationSettings',
  oneTimePasscode: 'oneTimePasscode',
  org: 'org',
  orgInfo: 'orgInfo',
  orgInfoList: 'orgInfoList',
  orgs: 'orgs',
  override: 'override',
  overtimePayStrategy: 'overtimePayStrategy',
  partner: 'partner',
  paymentGroups: 'paymentGroups',
  payments: 'payments',
  permissionConsent: 'permissionConsent',
  photo: 'photo',
  photos: 'photos',
  pin: 'PIN',
  pins: 'pins',
  pods: 'pods',
  preferences: 'preferences',
  processing: 'processing',
  programs: 'programs',
  public: 'public',
  publicInterestForms: 'publicInterestForms',
  prospectiveReport: 'v2/publicInterestForms/report',
  publicTourForms: 'publicTourForms',
  tourSlots: 'tourSlots',
  publicRegistrations: 'publicRegistrations',
  push: 'push',
  quickBooks: 'QuickBooks',
  rates: 'rates',
  read: 'read',
  readAll: 'readAll',
  receivablePayments: 'receivablePayments',
  refresh: 'refresh',
  registrationPresence: 'registrationPresence',
  registrationProposal: 'registrationproposal',
  registrations: 'registrations',
  registrationEmailTemplates: 'registrationEmailTemplates',
  registrationStatus: 'registrationStatus',
  reject: 'reject',
  remove: 'remove',
  replace: 'replace',
  requestApproval: 'requestApproval',
  rotessaConfig: 'payments/config',
  route: 'route',
  routine: 'routine',
  RunADFPipeline: 'RunADFPipeline',
  schools: 'schools',
  search: 'search',
  searchStaff: 'searchStaff',
  sessions: 'sessions',
  settings: 'settings',
  settle: 'settle',
  settlement: 'settlement',
  shared: 'shared',
  shareTokens: 'shareTokens',
  signature: 'signature',
  signedAgreementsAndPolicies: 'signedAgreementsAndPolicies',
  signIn: 'signIn',
  signOut: 'signOut',
  spaces: 'spaces',
  sponsor: 'sponsor',
  sponsoringMembers: 'sponsoringMembers',
  sponsors: 'orgInfo/sponsors',
  staff: 'staff',
  staffRoles: 'staffRoles',
  staffs: 'staffs',
  storedEmails: 'storedEmails',
  studentDirectory: 'studentDirectory',
  studentMedicationRecords: 'studentMedicationRecords',
  studentPausedPickup: 'studentPausedPickup',
  studentPublicRegistrations: 'studentPublicRegistrations',
  students: 'students',
  studentsForIncidentReport: 'incidentReport/students',
  studentsByIds: 'studentsByIds',
  studentsHavingMedications: 'studentsHavingMedications',
  studentsPaged: 'studentsPaged',
  subuser: 'subuser',
  sync: 'sync',
  tasks: 'orgInfo/tasks',
  teamRatioRule: 'teamRatioRules',
  teams: 'teams',
  thirdPartyAllocations: 'thirdPartyAllocations',
  token: 'token',
  transports: 'transports',
  tree: 'tree',
  unacknowledged: 'unacknowledged',
  undo: 'undo',
  undoClearAll: 'undo-clear-all',
  undoReadAll: 'undoReadAll',
  unread: 'unread',
  unreadCounts: 'unreadCounts',
  updateEnrollmentStatus: 'updateEnrollmentStatus',
  updateStudentLastMedicationComplete: 'updateStudentLastMedicationComplete',
  updateWaitlistPriority: 'updateWaitlistPriority',
  user: 'user',
  userCredentials: 'user/credentials',
  userPassword: 'users/password',
  users: 'users',
  validate: 'validate',
  verifyEmail: 'verifyEmail',
  versions: 'versions',

  // reports
  reports: 'reports',
  rosterRpt: 'reports/rosterDetails',
  licenseSummaryRpt: 'licenseSummary',
  groupSummaryRpt: 'groupSummary',
  studentStartingRpt: 'reports/studentStarting',
  studentChangingRpt: 'reports/studentChanges',
  studentEndingRpt: 'reports/studentEnding',
  mealRestrictRpt: 'reports/mealRestrict',
  medLogRpt: 'reports/medLog',
  incidentlogRpt: 'reports/incidentLog',
  illnesslogRpt: 'reports/illnessLog',
  medicalCareRpt: 'reports/medicalCare',
  studentDirectoryRpt: 'studentDirectory',
  studentBirthdayRpt: 'reports/studentBirthday',
  studentAgeChangeRpt: 'reports/studentAgeChanges',
  staffDirectoryRpt: 'staffDirectory',
  staffCertExpiryRpt: 'reports/staffCertificationExpiry',
  agreementsSignedRpt: 'reports/agreementsSigned',
  staffBirthdayRpt: 'reports/staffBirthday',
  hundredHrRpt: 'reports/ab100Hr',
  hundredHrRptDetails: '100HrRptDetails',
  preschoolDaysRpt: 'reports/abPreschoolDays',
  preschoolDaysRptDetails: 'preschoolDaysRptDetails',
  revPaySummaryRpt: 'revPaySummaryReport',
  feesRecordRpt: 'feesRecordReport',
  familyStatementsRpt: 'familyStatements',
  ARThirdpartyRpt: 'arThirdPartyReport',
  transactionReport: 'transactionReport',
  studentSummaryRpt: 'studentSummaryRpt',
  staffuser: 'staffuser',
  supportedVersions: 'supportedVersions',
  dailyStaffHoursSummary: 'dailyStaffHoursSummary',
  dailyStudentHoursSummary: 'dailyStudentHoursSummary',
  studentHoursOverview: 'studentHoursOverview',
  payroll: 'payroll',
  staffSignInDetail: 'staffSignInDetail',
  studentSignInDetail: 'studentSignInDetail',
  subsidyClaim: 'subsidyClaim',
  abClaims: 'abClaims',
  supplementalParentFees: 'supplementalParentFees',
  vaccineStatusRpt: 'reports/vaccineStatus',

  // configs
  userConfig: 'config/user',
  orgConfig: 'config/org',
  centerConfig: 'config/center',
}

export const QUICKBOOKS = {
  name: 'QuickBooks',
  callbackPath: '/callback/QuickBooks',
}

export const METHODS = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
  patch: 'PATCH',
}

export const STATUS_CODES = {
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  gone: 410,
  internalError: 500,
}

export const COMMON_KEYS = {
  appJson: 'application/json',
  contentType: 'content-type',
  feeCollectionDateFilter: 'feeCollectionDateFilter',
  language: 'language',
  darkMode: 'darkMode',
}

export const ERROR_TYPES = {
  internalError: 'internalError',
  notFoundError: 'notFoundError',
  unknownError: 'unknownError',
  validationError: 'validationError',
  networkError: 'networkError',
}

export const ATTENDEE_TYPES = {
  staff: 'staff',
  student: 'student',
}

export const ATTENDANCE_TYPES = {
  signIn: 'SignIn',
  signOut: 'SignOut',
  move: 'Move',
}

export const VERSIONS = {
  v1: 'v1',
  v2: 'v2',
}

export const LOADERS = {
  cli: 'cli',
  agg: 'agg',
  att: 'att',
  attendance: 'attendance',
  log: 'log',
  per: 'per',
  res: 'res',
  file: 'file',
  public: 'public',
  payProcessing: 'payProcessing',
  family: 'family',
  form: 'form',
  importer: 'importer',
  learn: 'learning',
  space: 'space',
  payment: 'payment',
  group: 'group',
  transport: 'transport',
  rate: 'rate',
  program: 'program',
  location: 'location',
  event: 'event',
  mgmt: 'mgmt',
  report: 'report',
  upload: 'upload',
  notification: 'notification',
  signalR: 'signalR',
}

export const daysOfWeek = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]
export const daysOfWeekSundayFirst = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]
export const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

export const LINE_ITEM_TYPES = {
  discount: 'Discount',
  charge: 'Charge',
}

export const BLOB_ACTIONS = {
  move: 'move',
  rename: 'rename',
  create: 'create',
  delete: 'delete',
}

export const GradeOrder = {
  move: 'move',
  rename: 'rename',
  create: 'create',
  delete: 'delete',
}

export const LAST_UPDATE_ANIM_TIMEOUT = 800

// A child may be pre-registered before birth. Bound how far out an expected
// birth date can be — a full-term pregnancy is ~9 months, so 10 months covers
// that plus a small buffer for due-date estimates, while still catching
// year-typos. Must match the backend bound in personnel-service-core's
// CommonUtil.MaxFutureDateOfBirthMonths.
export const MAX_FUTURE_DOB_MONTHS = 10

export const TEMPLATE_TYPES = {
  family: 'family',
  staff: 'staff',
  student: 'student',
}

export const LICENSES = {
  oosc: 'OOSC',
  daycare: 'Daycare',
}

export const AGE_RANGE_TYPES = {
  age: 'Age',
  grade: 'Grade',
}

export const REG_STATUS = {
  onboarding: 'Onboarding',
  active: 'Active',
  past: 'Past',
  pending: 'Pending',
  waitlisted: 'Waitlist',
  current: 'Current',
  registered: 'Registered',
  next: 'Next',
  future: 'Future',
  cancelled: 'Cancelled',
}

export const SponsorTypes = {
  unassigned: 'Unassigned',
  external: 'External',
  personal: 'Personal',
  anonymous: 'Anonymous',
}

export const PAYMENT_STATUS = {
  processing: 'Processing',
  processed: 'Processed',
  deposited: 'Deposited',
  settled: 'Settled',
  rejected: 'Rejected',
  close: 'Close',
  chargeback: 'Chargeback',
}

export const PAYMENT_METHOD = {
  pad: 'Pad',
  cash: 'Cash',
  check: 'Check',
  interac: 'Interac',
  creditCard: 'Credit Card',
  emailTransfer: 'Email Transfer',
  etf: 'ETF',
  credit: 'Credit',
}

export default {
  LICENSES,
}

export const RATE_CREDIT_TYPE = {
  daysPerWeek: 'Days per week',
}

export const RATE_CREDIT_STYLE = {
  fullTime: 'Full Time',
  partTime: 'Part Time',
  dropIn: 'Drop In',
}

export const STUDENT_STATUS = {
  pending: 'Pending',
  current: 'Current',
  future: 'Future',
  past: 'Past',
  inactive: 'Inactive',
}

export const STUDENT_SUB_STATUS = {
  onboarding: 'Onboarding',
  waitlist: 'Waitlist',
  toWithdraw: 'ToWithdraw',
  withdrawn: 'Withdrawn',
  toEnd: 'ToEnd',
  ended: 'Ended',
  completed: 'Completed',
}

export const IS_SCHOOL_REQUIRED_OPTIONS = {
  yes: 'Yes',
  no: 'No',
  optional: 'Optional',
}

export const GRADE_MAP: { [index: string]: number } = {
  Preschool: 0,
  Kindergarten: 1,
  'Grade 1': 2,
  'Grade 2': 3,
  'Grade 3': 4,
  'Grade 4': 5,
  'Grade 5': 6,
  'Grade 6': 7,
  'Grade 7+': 8,
}

export const UPLOAD_STATUS = {
  error: 'Error Occurred',
  finished: 'Finished',
  inProgress: 'In Progress',
  incorrectTemplate: 'Error- incorrect template',
  emailMissing: 'Error- Missing Email(s)',
}

export const USER_TYPES = {
  member: 'Member',
  student: 'Student',
}

export const INVOICE_STATUSES = {
  open: 'Open',
  processed: 'Processed',
  processing: 'Processing',
  deposited: 'Deposited',
  settled: 'Settled',
  close: 'Close',
}

export const SETTLEMENT_TAB_LABELS = {
  processed: { value: 'Processed', label: 'Processed' },
  deposited: { value: 'Deposited', label: 'Deposited' },
  settled: { value: 'Settled', label: 'Settled' },
}

export const MedicationDueMinutes = 15
export const PUBLIC_REGISTRATION_TYPE = {
  family: 'Family',
  student: 'Student',
}

export const ACTIVITY_TYPES = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Learning',
    value: 'Learning',
  },
  {
    label: 'Activity',
    value: 'Activity',
  },
  {
    label: 'Achievement',
    value: 'Achievement',
  },
  {
    label: 'Observations',
    value: 'Observations',
  },
  {
    label: 'Food',
    value: 'Food',
  },
  {
    label: 'Potty',
    value: 'Potty',
  },
  {
    label: 'Nap',
    value: 'Nap',
  },
  {
    label: 'Health',
    value: 'Health',
  },
  {
    label: 'Meds (Emergency/As Needed)',
    value: 'Meds',
  },
  {
    label: 'Incident',
    value: 'Incident',
  },
  {
    label: 'Meeting',
    value: 'Meeting',
  },
  {
    label: 'Notes',
    value: 'Notes',
  },
]

export const paymentColorMap: Record<string, string> = {
  Processing: 'grey-5',
  Settled: 'primary',
  Deposited: 'primary',
  Rejected: 'negative',
  Chargeback: 'red-5',
  Recovery: 'purple-8',
}

export const TabOptions = {
  active: 'Active',
  archived: 'Archived',
}

export const DefaultTabOptions = [TabOptions.active]

export const AgreementAndPolicyTypes = {
  mandatory: 'Mandatory',
  optional: 'Optional',
}

export const AgreementAndPolicyCategories = {
  registration: 'Registration',
}

export const InvoiceTypes = {
  normal: 'normal',
  reversal: 'reversal',
  recovery: 'recovery',
  merchantFee: 'merchant fee',
}

export const DepositGroupStatuses = {
  deposited: 'Deposited',
  settled: 'Settled',
}

export const MemberTypes = {
  legalGuardian: 'Legal Guardian',
  nonGuardianEmergencyContact: 'Non-Guardian Emergency Contact',
  other: 'Other',
}

export const StudentTagList = {
  basicInfo: 'Basic Info',
  licensingInfo: 'Licensing Info',
  healthcareInfo: 'Healthcare Info',
  emergencyContactInfo: 'Emergency Contact Info',
  legalGuardian: 'Legal Guardian',
  nonGuardianEmergencyContact: 'Non-Guardian Emergency Contact',
  autoInvoicing: 'Auto Invoicing',
  agreement: 'Agreement',
  waitlist: 'Waitlist',
  toWithdraw: 'To Withdraw',
  withdrawn: 'Withdrawn',
  toEnd: 'To End',
  ended: 'Ended',
  endingEnrollmentComplete: 'Ending-Enrollment-Complete',
}

export const StudentTagRequirementLevel = {
  required: 'Required',
  recommended: 'Recommended',
  na: 'N/A',
}

export const PaymentSources = {
  stripe: 'stripe',
  rotessa: 'rotessa',
}

export const BalanceStatuses = [
  'Credit Balance',
  'Zero',
  'Outstanding',
  '1 Month Past Due',
  '2 Months Past Due',
  '3+ Months Past Due',
]

export const AttendanceWarningColorMap = (isFloorMap?: boolean) => {
  return {
    'Exceeds max team size': WarningLevel.Negative,
    'Exceeds team ratio': WarningLevel.Negative,
    'Exceeds space max capacity': WarningLevel.Negative,
    'Missing permitted use': WarningLevel.Negative,
    'Missing staff': WarningLevel.Negative,
    'Missing team ratio': WarningLevel.Negative,
    'Forbidden age group detected': WarningLevel.Negative,
    'Mixed license': WarningLevel.Warning,
    'Extra staff': WarningLevel.Positive,
    ...(!isFloorMap && { Napping: WarningLevel.Warning }),
  } as { [index: string]: WarningLevel }
}

export const LineItemNames = {
  appliedCredits: 'Applied Credits',
  rejectedPayment: 'Rejected Payment',
  bouncedPayment: 'Bounced Payment',
}

export const AGE_GROUP_ICONS = {
  zeroToSixMonths: 'child_care',
  sixToTwelveMonths: 'child_care',
  twelveToTwentyFourMonths: 'child_care',
  twentyFourToThirtySixMonths: 'face',
  thirtySixToFourtyEightMonths: 'face',
  fourtyEightToSixtyMonths: 'face',
  kindergarten: 'school',
  beforeOrAfterSchool: 'schedule',
}

export interface OptionProp {
  label: string
  offset: number
  color: string
}

export const WEEKLY_QUICK_SELECT = [
  { label: 'This Week', offset: 0, color: 'primary' },
  { label: 'Next Week', offset: 1, color: 'positive' },
  { label: 'Week After', offset: 2, color: 'secondary-green' },
] as OptionProp[]

// Shouldn't retry token refresh for these routes or can hit an infinite loop or suppress errors
export const IGNORED_REFRESH_ROUTES = [
  'auth', // Admin Login
  'session/token', // Admin refresh
  'clientauth', // Client Login
  'session/clientToken', // Client refresh
  'device', // Device registration
]
